/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { Header } from "../header";
import { Sticky } from "../../basic/sticky";
import { HeaderSearch } from "../header-search";
import { CtaWrapper, LogoWrapper, SecondaryMenu, DefaultMenu, Login, Monogram } from "../header-helper-components";
import { accessCheck } from "../../../../isomorphic/utils";
import { DOUBLE_LAYER_ROOT_MARGIN } from "../../../constants";
import { Sidebar } from "../sidebar";
import "./header-one.m.css";
import { MobileDownloadLinks } from "../../atoms/mobile-apps";

export const HeaderOne = props => {
  const isSearchFormVisible = get(props, ["header", "isSearchFormVisible"]);
  const enableAppDownloadLinks = get(props, ["enableAppDownloadLinks"]);
  const showAppDownloadLinks = enableAppDownloadLinks ? "show-app-download-links" : "";
  const enabledAppDownloadLinks = enableAppDownloadLinks ? "app-download-links-enabled" : "secondary-menu";
  return (
    <Sticky rootMargin={DOUBLE_LAYER_ROOT_MARGIN}>
      <article styleName="sticky">
        <div styleName="layer-1">
          <div styleName="sidebar">
            <Sidebar {...props} {...props.isSidebarVisible} dataTestId="hamburger-icon-mobile" />
          </div>
          <div styleName="logo">
            <LogoWrapper {...props} />
          </div>
          {props.enableAppDownloadLinks && (
            <div styleName="download-links">
              <MobileDownloadLinks {...props} />
            </div>
          )}
          <div styleName={`${enabledAppDownloadLinks}`} data-test-id="secondary_menu">
            <SecondaryMenu {...props} customCssClasses={("header-one-secondary", `${showAppDownloadLinks}`)} />
          </div>
          <div styleName="cta-login-wrapper">
            <div styleName="cta">
              <CtaWrapper {...props} />
            </div>
            <div styleName="search">
              <HeaderSearch {...props} dataTestId="search-icon-mobile" />
            </div>
            {accessCheck(props.enableSSO) && (
              <div styleName="login">
                <Login {...props} />
              </div>
            )}
          </div>
        </div>
        <div styleName={`layer-2 ${isSearchFormVisible ? "show-search-form" : ""}`}>
          <div styleName="sidebar">
            <Sidebar {...props} {...props.isSidebarVisible} dataTestId="hamburger-icon" />
          </div>
          <div styleName="monogram">
            <Monogram {...props} />
          </div>
          <div styleName="default-menu" data-test-id="primary_menu">
            <DefaultMenu {...props} />
          </div>
          <div styleName="search">
            <HeaderSearch {...props} dataTestId="search-icon" />
          </div>
        </div>
      </article>
    </Sticky>
  );
};
HeaderOne.propTypes = {
  header: PropTypes.shape({
    isSearchFormVisible: PropTypes.bool
  }),
  isSidebarVisible: PropTypes.bool,
  toggleSearchForm: PropTypes.bool,
  hideSearchForm: PropTypes.bool,
  enableSSO: PropTypes.bool,
  enableAppDownloadLinks: PropTypes.bool
};

const HeaderTemplate = ({ showHeaderRowOnly = false }) => (
  <Header renderTemplate={HeaderOne} showHeaderRowOnly={showHeaderRowOnly} />
);

HeaderTemplate.propTypes = {
  showHeaderRowOnly: PropTypes.bool
};

export default HeaderTemplate;
